import React from 'react';

const ConfirmDialog = ({ 
  isOpen, 
  title, 
  message, 
  confirmLabel = 'Confirmer', 
  cancelLabel = 'Annuler', 
  confirmColor = 'primary',
  isProcessing = false,
  onConfirm, 
  onCancel 
}) => {
  if (!isOpen) return null;

  // Styles pour le bouton de confirmation basés sur la couleur
  const confirmButtonClass = `btn ${
    isProcessing ? 'loading' : ''
  } ${
    confirmColor === 'error' ? 'btn-error' : 
    confirmColor === 'warning' ? 'btn-warning' :
    confirmColor === 'success' ? 'btn-success' :
    'btn-primary'
  }`;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Overlay */}
      <div className="fixed inset-0 bg-black bg-opacity-50" onClick={onCancel}></div>
      
      {/* Modal */}
      <div className="bg-white rounded-lg shadow-lg max-w-md w-full mx-4 z-10">
        <div className="p-5">
          <h3 className="text-lg font-bold mb-2">{title}</h3>
          <p className="text-gray-700 mb-4">{message}</p>
          <div className="flex justify-end gap-2">
            <button
              onClick={onCancel}
              disabled={isProcessing}
              className="btn btn-outline"
            >
              {cancelLabel}
            </button>
            <button
              onClick={onConfirm}
              disabled={isProcessing}
              className={confirmButtonClass}
            >
              {confirmLabel}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;